// extracted by mini-css-extract-plugin
export default {"noScroll":"Modal_noScroll__w2Kc5","modalOverlay":"Modal_modalOverlay__18i9u","modalContent":"Modal_modalContent__d+R9n","closeIcon":"Modal_closeIcon__kDrQ8"};